import { dataPaperPlaneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaperPlaneSolid = /*#__PURE__*/createIcon(dataPaperPlaneSolid)
export default IconPaperPlaneSolid
